<template>
  <el-dialog width="45%"
             :visible.sync="visible"
             title="编辑零工工作信息">
    <el-form v-if="visible"
             ref="form"
             :model="model"
             size="medium"
             :rules="formRules"
             label-width="80px">
      <el-form-item label="行业"
                    prop="business_type">
        <el-select v-model="model.business_type"
                   @change="model.work_type=null"
                   class="width-max"
                   placeholder="请选择">
          <el-option v-for="item in otherOptions.business_type"
                     :disabled="item.disabled"
                     :key="item.id"
                     :label="item.title"
                     :value="item.id">
            <span style="float: left">{{ item.title }}</span>
            <span style="float: right; color: #8492a6; font-size: 13px">{{ item.subTitle }}</span>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="工种"
                    prop="work_type">
        <el-select v-model="model.work_type"
                   placeholder="请先选择行业"
                   class="width-max"
                   clearable>
          <el-option
            v-for="item in filtered_work_type"
            :disabled="item.disabled"
            :key="item.id"
            :label="item.title"
            :value="item.id">
            <span style="float: left">{{ item.title }}</span>
            <span style="float: right; color: #8492a6; font-size: 13px">{{ item.desc }}</span>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="主营品牌"
                    prop="main_brand"
                    v-if="needMainBrand()">
        <el-input v-model="model.main_brand"
                  class="width-max"
                  placeholder="请输入主营品牌"
                  clearable></el-input>
      </el-form-item>
      <el-form-item label="公司名称"
                    prop="belongto">
        <el-autocomplete
          v-model="model.belongto"
          :fetch-suggestions="queryCompanyList"
          placeholder="请输入或选择公司名称"
          class="width-max"
          clearable
          :trigger-on-focus="false"
          @select="handleCompanySelect">
        </el-autocomplete>
      </el-form-item>
      <el-form-item label="工作证明"
                    prop="workcard_photo">
        <el-upload action=""
                   :auto-upload="false"
                   :show-file-list="false"
                   accept=".jpg,.jpeg,.png,.mp4"
                   :on-change="query => onChangeFile(query)">
          <el-button type="primary"
                     size="small">上传工作证明
          </el-button>
        </el-upload>
        <div id="photoContainer"
             v-if="model.workcard_photo.length > 0">
          <template v-for="(photo, index) in model.workcard_photo">
            <div class="photo-item"
                 :key="'item-' + index"
                 style="position:relative;display:inline-block;margin:10px;vertical-align:top;">
              <!-- 视频缩略图 -->
              <video v-if="isVideoFile(photo)"
                     :src="photo"
                     preload="metadata"
                     style="width:80px;height:80px;display:block;object-fit:cover;cursor:pointer;background-color:#a9a5a5ff;"
                     @click="onPreviewVideo(photo)">
              </video>
              <!-- 图片缩略图 -->
              <img v-else
                   :src="photo | ossFormatJpg"
                   @click="onViewPhotos(index)"
                   style="width:80px;height:80px;display:block;object-fit:cover;cursor:zoom-in;">
              <!-- 右上角删除按钮 -->
              <i class="el-icon-error photo-delete-icon"
                 @click.stop="onDeletePhoto(index)"
                 style="position:absolute;top:-8px;right:-8px;font-size:20px;cursor:pointer;color:#f56c6c;background:#fff;border-radius:50%;width:20px;height:20px;display:flex;align-items:center;justify-content:center;box-shadow:0 2px 4px rgba(0,0,0,0.12);z-index:2;"></i>
            </div>
          </template>
        </div>
      </el-form-item>
    </el-form>
    <div slot="footer"
         class="dialog-footer">
      <el-button @click="visible = false"
                 size="small">取消
      </el-button>
      <el-button type="primary"
                 @click="submit"
                 size="small">确定
      </el-button>
    </div>

    <!-- 视频预览弹窗 -->
    <video-player-dialog
      :visible.sync="videoPreviewVisible"
      :videos="videoPreviewVideos"
      :index="videoPreviewIndex"/>
  </el-dialog>
</template>

<script>
import 'viewerjs/dist/viewer.css'
import Viewer from 'viewerjs'
import contentmenu from 'v-contextmenu'
import 'v-contextmenu/dist/index.css'
import userWorkInfoMixin from '@views/user-workinfo/user-workinfo.mixin.js'
import VideoPlayerDialog from '@views/user-workinfo/components/VideoPlayerDialog.vue'

Vue.use(contentmenu)

export default {
  components: {VideoPlayerDialog},
  mixins: [userWorkInfoMixin],
  computed: {
    ...Vuex.mapState({
      otherOptions: state => state.users.userOptions,
    }),
    filtered_work_type () {
      return this.otherOptions.business_work_type.filter(it => {
        return it.businessTypeId + '' === this.model.business_type + ''
      })
    }
  },
  data () {
    return {
      visible: false,
      viewer: null,
      videoPreviewVisible: false,
      videoPreviewVideos: [],
      videoPreviewIndex: 0,
      companyList: [],
      model: {
        id: null,
        business_type: null,
        work_type: null,
        belongto: null,
        main_brand: null,
        workcard_photo: [],
      },
      formRules: {
        business_type: [
          {required: true, message: '请选择行业', trigger: 'blur'},
        ],
        work_type: [
          {required: true, message: '请选择工种', trigger: 'blur'},
        ],
        belongto: [
          {required: true, message: '请输入公司名称', trigger: 'blur'},
        ],
        main_brand: [
          {required: true, message: '请输入主营品牌', trigger: 'blur'},
        ],
        workcard_photo: [
          {required: true, message: '请上传工作证明', trigger: 'blur'},
        ],
      },
    }
  },
  watch: {
    visible (value) {
      if (!value) {
        Object.assign(this.$data, this.$options.data.call(this))
      }
    }
  },
  methods: {
    ...request.map(['queryWorkInfoCompany']),
    open (id) {
      this.model.id = id
      this.setForm(id)
      this.visible = true
    },
    close () {
      this.visible = false
      this.$emit('submitted')
    },
    setForm (id) {
      request.page('getUser', id).then(({data}) => {
        filter.setLoop(this.model, data)
        this.model.business_type = this.model.business_type * 1
        if (this.model.business_type === 0) {
          this.model.business_type = null
        }
        if (this.model.work_type === 0) {
          this.model.work_type = null
        }
      })
    },
    getForm () {
      return filter.copyJson(this.model)
    },
    submit () {
      // 当前行业需要主营品牌时，前端做必填校验
      if (this.needMainBrand() && !this.model.main_brand) {
        this.$message.warning('当前行业需要填写主营品牌')
        return
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.update()
        } else {
          this.$message.error('提交内容填写不正确！')
        }
      })
    },
    update () {
      request.common('updateUserWorkinfo', this.getForm()).then(() => {
        this.visible = false
        this.$message.success('数据提交成功,已进入用户职业信息审核列表,请等待审核通过')
        this.model = {}
        this.$emit('submitted')
      })
    },
    async onChangeFile (file) {
      const url = await this.onChangeUserWorkInfoEvidence(file)
      if (url) {
        this.model.workcard_photo.push(url)
      }
    },
    onViewPhotos (index) {
      if (this.viewer) {
        this.viewer.destroy()
      }
      this.viewer = new Viewer(document.getElementById('photoContainer'))
      this.viewer.view(index)
    },
    onPreviewVideo (url) {
      // 构造所有视频 URL 列表，并计算当前点击视频的索引，交给 VideoPlayerDialog 播放
      const videoList = (this.model.workcard_photo || []).filter(photo => this.isVideoFile(photo))
      this.videoPreviewVideos = videoList
      this.videoPreviewIndex = Math.max(videoList.indexOf(url), 0)
      this.videoPreviewVisible = true
    },
    onDeletePhoto (index) {
      this.model.workcard_photo.splice(index, 1)
    },
    async queryCompanyList (queryString, cb) {
      // 如果查询字符串为空，返回空数组
      if (!queryString || queryString.trim() === '') {
        const emptyList = []
        cb(emptyList)
        return
      }

      try {
        // 调用后端API进行远程搜索
        const {data} = await request.common('queryWorkInfoCompany', {
          name: queryString.trim(),
          per_page: 20, // 限制返回数量
          current_page: 1,
        })

        const companies = (data && data.data) || []
        // 格式化数据为 el-autocomplete 需要的格式
        const formattedResults = companies.map(company => ({
          value: company.name,
          id: company.id,
        }))
        cb(formattedResults)
      } catch (error) {
        console.error('搜索公司失败:', error)
        // 出错时返回空数组
        const emptyList = []
        cb(emptyList)
      }
    },
    handleCompanySelect (item) {
      this.model.belongto = item.value
    },
    needMainBrand () {
      const btId = this.model.business_type
      if (!btId) return false
      const item = (this.otherOptions.business_type || []).find(it => Number(it.id) === Number(btId))
      return item && item.need_main_brand
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/users/components/UpdateWorkInfoDialog.vue